import React from 'react';
import { Box, Typography, Autocomplete, TextField } from '@mui/material';
import {
	accountNameFromType,
	type Account,
	accountNameWithoutType,
} from '../../api/models/account.model';
import { useDispatch, useSelector } from 'react-redux';
import { useGetAccountsQuery } from '../../api/account.api';
import { selectAccount, setSelectedAccount } from '../../redux/slices/accountSlice';
import { LOADING_WITH_ELLIPSIS, SELECT_AN_ACCOUNT } from '../../constants/messages';

function InternalLesseeDropdown() {
	const dispatch = useDispatch();
	const [searchValue, setSearchValue] = React.useState('');
	const [inputValue, setInputValue] = React.useState('');
	const activeAccount = useSelector(selectAccount);

	// Fetch accounts using the RTK Query hook
	const { data: accounts, isLoading } = useGetAccountsQuery(searchValue);

	const handleLesseeSelect = React.useCallback(
		(option: Account) => {
			dispatch(setSelectedAccount(option));
		},
		[dispatch]
	);

	function label(): string {
		if (isLoading) {
			return LOADING_WITH_ELLIPSIS;
		}
		return '';
	}

	React.useEffect(() => {
		const handler = setTimeout(() => {
			setSearchValue(accountNameWithoutType(inputValue));
		}, 500);
		return () => {
			clearTimeout(handler);
		};
	}, [inputValue]);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				width: '100%',
				justifyContent: 'end',
				paddingRight: { xs: 4, sm: 0 },
			}}
		>
			<Typography
				variant="body1"
				sx={{
					mr: 1,
					fontWeight: 'bold',
					color: 'common.white',
					width: '6rem',
					margin: 0,
				}}
			>
				{label()}
			</Typography>
			<Autocomplete
				data-testid="main-nav-account-dropdown-input"
				disablePortal
				size="small"
				sx={{ width: '65%' }}
				options={accounts || []}
				getOptionLabel={(option) => accountNameFromType(option)}
				value={activeAccount}
				onInputChange={(_, newInputValue) => {
					setInputValue(newInputValue);
				}}
				onChange={(_, newValue) => {
					if (newValue) {
						handleLesseeSelect(newValue);
					}
				}}
				isOptionEqualToValue={(option, value) => option.accountId === value.accountId}
				renderInput={(params) => (
					<TextField
						{...params}
						label={SELECT_AN_ACCOUNT}
						slotProps={{
							inputLabel: {
								sx: {
									color: 'common.white',
									top: -10,
									left: -10,
								},
							},
						}}
						sx={{ bgcolor: 'white', borderRadius: 1 }}
					/>
				)}
			/>
		</Box>
	);
}

export default InternalLesseeDropdown;
